import { NoVehiclesAvailableCard, VehicleChooser } from '@/components';
import clsx from 'clsx';
import { SharedVehicle } from '@/types/types';

const VehiclesDisplay = ({
    vehicles,
    type,
}: {
    vehicles: SharedVehicle[];
    type: 'car' | 'van';
}) => {
    const gridClasses = clsx(
        'w-full',
        'grid',
        'grid-cols-1',
        vehicles.length > 1 && 'sm:grid-cols-2',
        vehicles.length > 2 && 'lg:grid-cols-3',
        'gap-2',
        'mb-4',
        // Center items when less than 3 vehicles
        vehicles.length < 3 && 'lg:justify-items-center lg:place-content-center'
    );

    return (
        <div className={gridClasses}>
            {vehicles.length > 0 ? (
                vehicles.map((vehicle) => {
                    const {
                        title,
                        imageUrl,
                        imageAlt,
                        currentSlug,
                        vehicleSpecifications,
                        vehicleHireProps,
                        _id,
                    } = vehicle;
                    return (
                        <VehicleChooser
                            title={title ?? 'Vehicle'}
                            vehicleImage={imageUrl as string}
                            alt={imageAlt ?? 'Vehicle image'}
                            key={_id}
                            vehicleId={_id}
                            slug={currentSlug ?? ''}
                            vehicleSpecifications={vehicleSpecifications}
                            vehicleHireProps={vehicleHireProps}
                        />
                    );
                })
            ) : (
                <NoVehiclesAvailableCard type={type} />
            )}
        </div>
    );
};

export default VehiclesDisplay;
